import React from 'react'
import { Form, Button } from 'semantic-ui-react'
import { CommonField } from '@bsd/dashboard-toolkit/components/forms'
import { InputField } from '@bsd/dashboard-toolkit/components/forms/fields'

import { DEFAULT_LOCALE, LOCALES } from '../constants'
import IconField from './fields/IconField'
import LocalizationField from './fields/LocalizationField'


const CategoryLocaleForm = ({ data, onChange }) =>
  <>
    <Form.Field>
      <label>Название</label>
      <InputField value={data.name} onChange={onChange('name')}/>
    </Form.Field>
  </>

class GeoCategoryForm extends React.Component {

  constructor(props) {
    super(props)
    const data = props.initialData || {}

    let locales = { ...data.locales }
    LOCALES.forEach(locale => {
      if (!locales[locale.code]) {
        locales[locale.code] = { name: '' }
      }
    })
    this.state = {
      data: {
        icon: data.icon || '',
        locales,
      },
      errors: {},
    }
  }

  handleFieldChange = (field) => (value) => {
    const newData = { ...this.state.data }
    const newErrors = { ...this.state.errors }
    delete newErrors[field]
    newData[field] = value
    this.setState({ data: newData, errors: newErrors })
  }

  validate = () => {
    const data = { ...this.state.data }
    const errors = {}
    if (!data.locales[DEFAULT_LOCALE].name) {
      errors[`locales.${DEFAULT_LOCALE}.name`] = 'Введите название'
    }
    this.setState({ errors })
    return !Object.keys(errors).length
  }

  handleSubmit = (e) => {
    if (e) { e.preventDefault() }
    if(this.validate()) {
      this.props.onSubmit(this.state.data)
    }
  }

  render() {
    const { data, errors } = this.state
    return (
      <Form style={{ maxWidth: '700px' }} onSubmit={this.handleSubmit}>
        <CommonField
          field={{
            label: 'Иконка',
            input: IconField,
          }}
          value={data.icon}
          onChange={this.handleFieldChange('icon')}
          error={errors['icon']}
        />
        <CommonField
          field={{
            label: `Название (${DEFAULT_LOCALE})`,
            input: InputField,
          }}
          value={data.locales[DEFAULT_LOCALE].name}
          onChange={(value) => {
            let locales = { ...data.locales }
            locales[DEFAULT_LOCALE].name = value
            this.handleFieldChange('locales')(locales)
            const errors = { ...this.state.errors }
            delete errors[`locales.${DEFAULT_LOCALE}.name`]
            this.setState({ errors })
          }}
          error={errors[`locales.${DEFAULT_LOCALE}.name`]}
        />
        <CommonField
          field={{
            label: 'Локализация',
            input: LocalizationField,
            inputProps: {
              localeForm: CategoryLocaleForm,
            },
          }}
          value={data.locales}
          onChange={this.handleFieldChange('locales')}
          error={errors['locales']}
        />
        <div style={{ textAlign: 'right' }}>
          <Button
            basic color='green' icon='save'
            content='Сохранить'
            style={{ marginRight: 0 }}
            onClick={this.handleSubmit}
          />
        </div>
      </Form>
    )
  }

}

export default GeoCategoryForm